import React from 'react';
import { BlockIcon } from './icons';

const ModalUpsellTextButton = ({ product, index, indexAdded }) => {
  // Check if the current index is the same as indexAdded
  if (indexAdded === index) {
    return (
      <>
        <BlockIcon icon="tick" />
        Added to Cart
      </>
    );
  }

  // Check for outDateOffer and availability
  if (product.metafields.outDateOffer) {
    return "Out Date";
  }

  if (product.available) {
    return indexAdded !== -1 ? "Select This Instead" : "Add";
  }

  return "Out Stock";
};


export default ModalUpsellTextButton;